import { Text } from '@oneaudi/unified-web-components';
import React from 'react';
import type { FC } from 'react';

import styled from 'styled-components';
import { UeElement } from '@oneaudi/falcon-tools';
import { useContent } from '../context/ContentContext';

export const StyledDisclaimer = styled.div`
  margin-top: var(--spacing-relative-2xl);
`;

const Disclaimer: FC = () => {
  const { disclaimer } = useContent();

  if (!disclaimer) {
    return null;
  }

  return (
    <StyledDisclaimer>
      <Text
        variant={{
          order: '2',
          style: 'normal',
          type: 'copy',
        }}
        data-testid="disclaimer"
      >
        <UeElement type="text" property="disclaimer" label="Disclaimer">
          {disclaimer}
        </UeElement>
      </Text>
    </StyledDisclaimer>
  );
};

export default Disclaimer;
